import { Box } from '@mui/material';

export default function PartnerRowWrap({
  children,
}: {
  children: React.ReactElement | React.ReactElement[];
}) {
  return (
    <Box
      width='600px'
      display='flex'
      flexGrow={1}
      flexDirection='row'
      flexWrap='wrap'
      justifyContent='space-between'
      gap={'35px'}
    >
      {children}
    </Box>
  );
}
